module.exports = __webpack_public_path__ + "media/images/baslow3-177bdb12c9663cf6ba49640207796361.jpg";